export interface Point {
  x: number
  y: number
}

export interface Vector {
  dx: number
  dy: number
}

export interface Size {
  width: number
  height: number
}

export interface Rect {
  origin: Point
  size: Size
}

export function pointEquals (lhs: Point, rhs: Point) {
  return lhs.x === rhs.x && lhs.y === rhs.y
}

export function sizeEquals (lhs: Size, rhs: Size) {
  return lhs.width === rhs.width && lhs.height === rhs.height
}

export function rectEquals (lhs: Rect, rhs: Rect) {
  return pointEquals(lhs.origin, rhs.origin) && sizeEquals(lhs.size, rhs.size)
}

export function vectorLength (vector: Vector) {
  return Math.sqrt(vector.dx * vector.dx + vector.dy * vector.dy)
}

export function vectorAngle (vector: Vector) {
  return Math.atan2(vector.dy, vector.dx) * 180 / Math.PI
}

export function vectorFromPoints (p0: Point, p1: Point) {
  return {
    dx: p1.x - p0.x,
    dy: p1.y - p0.y
  }
}

/**
 * Convert point as a tuple (array) to Point
 * @param tuple tuple to be converted to point
 */
export function tupleToPoint (tuple: [number, number]): Point {
  const [x, y] = tuple
  return { x, y }
}

/**
 * Convert point to tuple (array)
 * @param point point to be converted to tuple
 */
export function pointToTuple (point: Point): [number, number] {
  const { x, y } = point
  return [x, y]
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/BasicTypes.ts